class Notice {
    public url: string = '';
    public action: string = '';

    constructor(url: string, action: string) {
        this.url = url;
        this.action = action;
    }
}
export default Notice;